import React from 'react';
import { Calendar, TrendingUp, Award, Building2, FileText } from 'lucide-react';
import { useTranslations } from '../hooks/useTranslations';
export function Requirements() {
  const {
    t
  } = useTranslations();
  return <section id="requirements" className="py-10 bg-[#f0faf4]" data-id="element-361">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-362">
        <div className="text-center mb-8" data-id="element-363">
          <p className="text-xs font-bold tracking-widest text-gray-500 uppercase mb-2" data-id="element-364">
            {t('requirements.eyebrow')}
          </p>
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900" data-id="element-365">
            {t('requirements.title')}
          </h2>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-4 mb-8" data-id="element-366">
          <div className="bg-white rounded-xl p-5 shadow-sm border border-gray-100 text-center" data-id="element-367">
            <div className="w-12 h-12 rounded-lg bg-purple-500 flex items-center justify-center mx-auto mb-3" data-id="element-368">
              <Calendar className="w-6 h-6 text-white" data-id="element-369" />
            </div>
            <h3 className="text-lg font-bold text-gray-900" data-id="element-370">
              {t('requirements.req1.title')}
            </h3>
            <p className="text-xs text-gray-500 mt-1" data-id="element-371">
              {t('requirements.req1.desc')}
            </p>
          </div>

          <div className="bg-white rounded-xl p-5 shadow-sm border border-gray-100 text-center" data-id="element-372">
            <div className="w-12 h-12 rounded-lg bg-blue-500 flex items-center justify-center mx-auto mb-3" data-id="element-373">
              <TrendingUp className="w-6 h-6 text-white" data-id="element-374" />
            </div>
            <h3 className="text-lg font-bold text-gray-900" data-id="element-375">
              {t('requirements.req2.title')}
            </h3>
            <p className="text-xs text-gray-500 mt-1" data-id="element-376">
              {t('requirements.req2.desc')}
            </p>
          </div>

          <div className="bg-white rounded-xl p-5 shadow-sm border border-gray-100 text-center" data-id="element-377">
            <div className="w-12 h-12 rounded-lg bg-orange-500 flex items-center justify-center mx-auto mb-3" data-id="element-378">
              <Award className="w-6 h-6 text-white" data-id="element-379" />
            </div>
            <h3 className="text-lg font-bold text-gray-900" data-id="element-380">
              {t('requirements.req3.title')}
            </h3>
            <p className="text-xs text-gray-500 mt-1" data-id="element-381">
              {t('requirements.req3.desc')}
            </p>
          </div>

          <div className="bg-white rounded-xl p-5 shadow-sm border border-gray-100 text-center" data-id="element-382">
            <div className="w-12 h-12 rounded-lg bg-emerald-500 flex items-center justify-center mx-auto mb-3" data-id="element-383">
              <Building2 className="w-6 h-6 text-white" data-id="element-384" />
            </div>
            <h3 className="text-lg font-bold text-gray-900" data-id="element-385">
              {t('requirements.req4.title')}
            </h3>
            <p className="text-xs text-gray-500 mt-1" data-id="element-386">
              {t('requirements.req4.desc')}
            </p>
          </div>

          <div className="bg-white rounded-xl p-5 shadow-sm border border-gray-100 text-center col-span-2 sm:col-span-1" data-id="element-387">
            <div className="w-12 h-12 rounded-lg bg-red-500 flex items-center justify-center mx-auto mb-3" data-id="element-388">
              <FileText className="w-6 h-6 text-white" data-id="element-389" />
            </div>
            <h3 className="text-lg font-bold text-gray-900" data-id="element-390">
              {t('requirements.req5.title')}
            </h3>
            <p className="text-xs text-gray-500 mt-1" data-id="element-391">
              {t('requirements.req5.desc')}
            </p>
          </div>
        </div>

        <div className="text-center" data-id="element-392">
          <p className="text-xs text-gray-500" data-id="element-393">{t('requirements.subtitle')}</p>
        </div>
      </div>
    </section>;
}